export default "<div class=\"example-loading-shade\">\r\n  <mat-spinner></mat-spinner>\r\n</div>\r\n"